import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionCta } from './SectionCta';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-5 py-16 sm:py-24" aria-labelledby="faq-title" data-id="element-126" data-mp="1gd7hib8p3f72">
      <div className="mx-auto max-w-3xl" data-id="element-127" data-mp="2e0g1g1t1sg6y">
        <h2 id="faq-title" className="text-center font-display text-4xl font-bold uppercase leading-tight text-navy-900 sm:text-5xl" data-id="element-128" data-mp="2dz4whynv92e9">
          Frequently asked questions
        </h2>

        <div className="mt-10 divide-y divide-navy-900/10 border-y border-navy-900/10" data-id="element-129" data-mp="240p65xwnxx5t">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-130" data-mp="snwcghkbayn4" data-mpi={i}>
                <h3 data-id="element-131" data-mp="sl0ggys0yk1b">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 py-5 text-left text-lg font-semibold text-ink focus:outline-none focus-visible:text-radar-deep" data-id="element-132" data-mp="no0cquindtdd">
                    {f.q}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-radar-deep transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-133" data-mp="khjs3ync4lua" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-134" data-mp="3swk13aavv3s5">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-135" data-mp="1smxturxttc2">
                      <p className="pb-5 text-[17px] leading-relaxed text-muted" data-id="element-136" data-mp="1potb6cn40p1l">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <SectionCta label="I'm convinced — give me access" data-id="element-137" data-mp="2dfgojdfso6vj" />
      </div>
    </section>;
}